import { ColDef } from 'ag-grid-community';
import { DefaultCellTooltip } from 'components/grids/tooltip/DefaultCellTooltip';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import radioIcon from 'components/asset/RadioColumn.svg';

export const useManagerSearchSingleColumnDefs = () => {
  const { t } = useTranslation();
  const defaultColDef = useMemo((): ColDef => {
    return {
      sortable: false,
      resizable: true,
      cellStyle: { textAlign: 'center' },
      tooltipComponent: DefaultCellTooltip,
    };
  }, []);

  const colDefs = useMemo((): any[] => {
    return [
      {
        headerName: 'radio',
        headerComponentParams: {
          template: `<img src=${radioIcon} alt=''/>`,
        },
        width: '28px !important',
        height: '24px !important',
        padding: '2px 6px',
        resizable: false,
        headerCheckboxSelection: true,
        showDisabledCheckboxes: true,
        checkboxSelection: true,
        flex: 0,
        cellStyle: {
          display: 'flex',
          justifyContent: 'center',
          width: '28px !important',
          height: '24px',
        },
      },
      {
        headerName: t('com.label.00012', '__이름'),
        field: 'empNm',
        tooltipField: 'empNm',
        flex: 1,
      },
      {
        headerName: t('com.label.jpsOrJgd', '__직책/직급'),
        field: 'jtiNm',
        tooltipField: 'jtiNm',
        flex: 1,
      },
      {
        headerName: t('com.label.dept', '__부서'),
        field: 'deptNm',
        tooltipField: 'deptNm',
        cellStyle: { textAlign: 'left' },
        flex: 1,
      },
    ];
  }, []);

  return { defaultColDef, colDefs };
};
